(function () {
  if (window.__productMediaClaimsLoaded) return;
  window.__productMediaClaimsLoaded = true;

  function closeAll(except) {
    document.querySelectorAll('.product-media-claims__button.is-active').forEach((btn) => {
      if (btn !== except) btn.classList.remove('is-active');
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('.product-media-claims__button');
    if (!button) {
      closeAll();
      return;
    }
    const next = !button.classList.contains('is-active');
    closeAll(button);
    button.classList.toggle('is-active', next);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });
})();
